if (!customElements.get('sdc-cart-expiry')) {
  customElements.define('sdc-cart-expiry', class extends HTMLElement {
    connectedCallback() {
      this.key = 'sdc-cart-expiry-v1';
      this.storageChanged = () => this.tick();
      this.visibilityChanged = () => { if (!document.hidden) this.tick(); };
      if (Number(this.dataset.count) === 0) {
        this.save(0);
        return;
      }
      this.deadline = this.read() || Date.now() + 600000;
      this.save(this.deadline);
      this.clock = this.querySelector('[data-cart-countdown]');
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
      window.addEventListener('storage', this.storageChanged);
      document.addEventListener('visibilitychange', this.visibilityChanged);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      window.removeEventListener('storage', this.storageChanged);
      document.removeEventListener('visibilitychange', this.visibilityChanged);
    }
    read() {
      try { return Number(localStorage.getItem(this.key)) || 0; } catch { return this.deadline || 0; }
    }
    save(value) {
      this.deadline = value;
      try {
        if (value) localStorage.setItem(this.key, String(value));
        else localStorage.removeItem(this.key);
      } catch {}
    }
    tick() {
      if (!this.isConnected || this.clearing) return;
      const deadline = this.read();
      if (deadline) this.deadline = deadline;
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.clock.textContent = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
      if (!remaining && Date.now() >= (this.retryAfter || 0)) this.expire();
    }
    async expire() {
      this.clearing = true;
      try {
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : `${this.dataset.root}/`;
        const drawer = document.querySelector('cart-drawer');
        const response = await fetch(`${root}cart/clear.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({sections: drawer.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname})
        });
        if (!response.ok) throw new Error('Cart expiry failed');
        const result = await response.json();
        this.save(0);
        clearInterval(this.interval);
        drawer.classList.add('is-empty');
        drawer.renderContents(result);
      } catch {
        this.retryAfter = Date.now() + 5000;
      } finally {
        this.clearing = false;
      }
    }
  });
}
